import {useFetch} from "../useFetch";
import {TypeContainerPlatforms} from "../../types/api/guide/typeContainerPlatform.types";
import {typeContainerPlatformsService} from "../../services/guide/typeContainerPlatforms-service";

export const useFetchAllTypeContainerPlatforms = () => {
    const { isLoading, error, data, refetch } = useFetch<TypeContainerPlatforms[]>(typeContainerPlatformsService.getAll);

    return { data: data || [], isLoading, error, refetch };
}
